import React from "react";

/** Named groups of honoured guests — padres, padrinos, testigos. */
export function HonorList({ groups = [], columns = 1, tone = "default", style }) {
  const fg = tone === "onDark" ? "var(--fg-on-contrast)" : "var(--fg-primary)";
  const muted = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 60%, transparent)" : "var(--fg-muted)";
  return (
    <div style={{ display: "grid", gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: "var(--sp-6)", textAlign: "center", ...style }}>
      {groups.map((g, i) => (
        <div key={i} style={{ display: "grid", gap: "var(--sp-2)" }}>
          <p style={{ margin: 0, fontFamily: "var(--font-caps)", fontSize: "var(--fs-micro)", letterSpacing: "var(--ls-widest)", textTransform: "uppercase", color: muted }}>{g.title}</p>
          {g.names.map((n, j) => (
            <p key={j} style={{ margin: 0, fontFamily: "var(--font-title, var(--font-display))", fontSize: "var(--fs-body-l)", lineHeight: "var(--lh-snug)", color: fg }}>{n}</p>
          ))}
        </div>
      ))}
    </div>
  );
}
